// @flow
import jwt from '../../utils/jwt'

/**
 * Returns whether a user is logged in or not
 * @type {Boolean}
 * @return {Boolean} Whether user is logged in or not
 */
export const isLoggedIn = (): boolean => jwt.isAuthenticated()

export default isLoggedIn
